import { createRouter, createWebHistory } from "vue-router";
import BooIndex from "../views/BooIndex.vue";
import Product from "../views/Product.vue";
import NewsInformation from "../views/NewsInformation.vue";
import JoinUs from "@/views/JoinUs.vue";
import JobDesign from '@/views/joinChildren/JobDesign.vue'
import JobFunction from '@/views/joinChildren/JobFunction.vue'
import JobStudent from '@/views/joinChildren/JobStudent.vue'
import JobTechnology from '@/views/joinChildren/JobTechnology.vue'

const routes = [
  {
    path: "/",
    name: "home",
    component: BooIndex,
  },
  {
    path: "/product",
    name: "product",
    component: Product,
  },
  {
    path: "/newsInformation",
    name: "newsInformation",
    component: NewsInformation,
  },
  {
    path: "/joinUs",
    name: "joinUs",
    component: JoinUs,
    children: [
      {
        name: "jobDesign",
        path: "/jobDesign",
        component: JobDesign,
      },
      {
        name: "jobFunction",
        path: "/jobFunction",
        component: JobFunction,
      },
      {
        name: "jobStudent",
        path: "/jobStudent",
        component: JobStudent,
      },
      {
        name: "jobTechnology",
        path: "/jobTechnology",
        component: JobTechnology,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 };
  },
});

export default router;
